/**
 * @prettier
 */

import React from 'react';
import { connect } from 'react-redux';
import { Link } from '@zola/zola-ui';
import { openModal } from 'cards/actions/modalActions';
import FeatureFlags from '../../../../../util/featureFlags';
import styles from './styles.module.less';

const supportedCardTypes = ['SAVE_THE_DATE', 'INVITATION'];

export const SingleSampleModalLinkBasePLP = ({ card, showModal }) => {
  if (!FeatureFlags.get('invitesSingleSampleModal') || !card || !supportedCardTypes.includes(card.type)) {
    return null;
  }

  return (
    <div className={styles.linkBox}>
      <Link inline role="button" onClick={() => showModal({ card })} arrow>
        Order A Free Sample
      </Link>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  showModal: props => dispatch(openModal('SINGLE_SAMPLE_MODAL', props, { warnOnClose: true })),
});

export default connect(null, mapDispatchToProps)(SingleSampleModalLinkBasePLP);



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/SingleSampleModalLinkPLP/SingleSampleModalLinkPLP.jsx